// extracted by mini-css-extract-plugin
module.exports = {"draw-button":"_2on7YZXKtO5Z2z11J04W"};